import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Merry Christmas and happy coding!`}</p>
    <h1>{`Hack`}</h1>
    <p>{`Inspired by `}<a parentName="p" {...{
        "href": "http://asciimoji.com/"
      }}>{`this`}</a>{` chrome plugin I added some `}<a parentName="p" {...{
        "href": "https://github.com/Shougo/denite.nvim"
      }}>{`Denite`}</a>{` menu to help type emoji in vim. I would say `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/neovim/nvim/config/functions/asciiemoji.vimrc"
      }}>{`this`}</a>{` should be an `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`efficiency`}</code>{` tool to motivate people leave comment for their code. Sometime it can catch code reviewer attention as well. Yeah, ʕ·͡ᴥ·ʔ. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      